import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

// http://playable.dev.com:8067/doc?doc=report/creative.go

export function getMaterialReport(apiPath, params) {
  return request({
    url: `${v2Host}${apiPath}`,
    method: 'get',
    params: cookRequestParams(params)
  })
}

export function getMaterialReportCount(apiPath, params) {
  return request({
    url: `${v2Host}${apiPath}`,
    method: 'get',
    params: cookRequestParams(params)
  })
}

/**
 * http://playable.dev.com:8067/doc?doc=report/creative.go#%2freport%2fcreative%2fsizer-option
 * @param {{sizer: number, name?: string, page?: string, page_size?: string}} params
 */
export function getSizerOption(params) {
  return request({
    url: `${v2Host}/report/creative/sizer-option`,
    method: 'get',
    params: params
  })
}

// http://localhost:8067/index.html#/report/get_report_playable_stat_list
export function getPlayableStatCount(params) {
  return request({
    url: `${v2Host}/report/playable-stat/count`,
    method: 'get',
    params: cookRequestParams(params)
  })
}

// http://localhost:8067/index.html#/report/get_report_playable_stat_list
export function getPlayableStatExport(params) {
  return request({
    url: `${v2Host}/report/playable-stat/export`,
    method: 'get',
    params: cookRequestParams(params)
  })
}

// http://localhost:8067/index.html#/report/get_report_playable_stat_list
export function getPlayableStatList(params) {
  return request({
    url: `${v2Host}/report/playable-stat/list`,
    method: 'get',
    params: cookRequestParams(params)
  })
}
